import styled, { keyframes } from 'styled-components';

const scaleIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const cubicBezier = `cubic-bezier(0.34, 1.56, 0.64, 1)`;

const duration = '300ms';

export const ScaleIn = styled('div')`
  animation: ${scaleIn} 700ms ${cubicBezier} forwards;
`;

export const FadeIn = styled('div')`
  animation: ${fadeIn} ${duration} linear forwards;
`;
